import React from 'react';

export const LoadingCircleComponent = () => {
    return (
        <div style={{ width: '100%', textAlign: 'center' }}>
            <div className="loader"></div>
        </div>
    );
}